import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ImageDropzone } from "./ImageDropzone";
import type { SEOConfig } from "./types";
interface SEOSettingsProps {
  settings: SEOConfig;
  onChange: (settings: SEOConfig) => void;
}
export const SEOSettings = ({
  settings,
  onChange
}: SEOSettingsProps) => {
  const handleChange = (field: keyof SEOConfig, value: string) => {
    onChange({
      ...settings,
      [field]: value
    });
  };
  return <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="seoTitle">Oldal cím</Label>
        <Input id="seoTitle" value={settings.title} onChange={e => handleChange("title", e.target.value)} placeholder="Enter page title" className="bg-white" />
      </div>

      <div className="space-y-2">
        <Label htmlFor="metaKeywords">Meta Kulcsszavak</Label>
        <Input id="metaKeywords" value={settings.metaKeywords} onChange={e => handleChange("metaKeywords", e.target.value)} placeholder="Enter keywords, separated by commas" className="bg-white" />
      </div>

      <div className="space-y-2">
        <Label htmlFor="metaDescription">Meta Leírás</Label>
        <Textarea id="metaDescription" value={settings.metaDescription} onChange={e => handleChange("metaDescription", e.target.value)} placeholder="Enter page description" className="bg-white min-h-[100px]" />
      </div>

      <div className="space-y-2">
        <Label>Megosztási kép</Label>
        <ImageDropzone value={settings.ogImage} onChange={base64 => handleChange("ogImage", base64)} />
      </div>
    </div>;
};